import {isOffline} from "@/js/offline-utils";

let settings = {};

settings = {
  APP_URL: window.env.VITE_APP_URL ?? import.meta.env.VITE_APP_URL ?? undefined,
  API_URL: window.env.VITE_API_URL ?? import.meta.env.VITE_API_URL ?? '/api/v1/',
  API_URL_V2: window.env.VITE_API_URL_V2 ?? import.meta.env.VITE_API_URL_V2 ?? '/api/v2/',
  USE_VERSIONED_API: window.env.VITE_USE_VERSIONED_API ?? import.meta.env.VITE_USE_VERSIONED_API ?? undefined,
  SYNC_API_URL: window.env.VITE_SYNC_API_URL ?? import.meta.env.VITE_SYNC_API_URL ?? '/api/v1/',
  STREAMING_API_URL: window.env.VITE_STREAMING_API_URL ?? import.meta.env.VITE_STREAMING_API_URL ?? '/api/v1/',
  LOCAL_API_URL_SIGNATURE: window.env.VITE_LOCAL_API_URL_SIGNATURE ?? import.meta.env.VITE_LOCAL_API_URL_SIGNATURE ?? 'http://localhost:5000/',
  APP_LOGO: window.env.VITE_APP_LOGO ?? import.meta.env.VITE_APP_LOGO ?? '/images/logo.svg',
  APP_ICON: window.env.VITE_APP_ICON ?? import.meta.env.VITE_APP_ICON ?? '/images/syncmap.png',
  MAPBOX_TOKEN: window.env.VITE_MAPBOX_TOKEN ?? import.meta.env.VITE_MAPBOX_TOKEN ?? 'pk.eyJ1IjoiZ2VvZGF0YS1zZXJ2aWNlcyIsImEiOiJja3J1Zzg1M3QxMXo5MnVucGdidHg5Mzl5In0.h-zRgBPYOJ8APe-8TILqQw',
  SYNCMAP_URLS: (window.env.VITE_SYNCMAP_URLS ?? import.meta.env.VITE_SYNCMAP_URLS) ? JSON.parse(window.env.VITE_SYNCMAP_URLS ?? import.meta.env.VITE_SYNCMAP_URLS) : [],
  TILES_URL: window.env.VITE_TILES_URL ?? import.meta.env.VITE_TILES_URL ?? 'https://tiles.gis-solution.ro',
  SOCKET_URL: window.env.VITE_SOCKET_URL ?? import.meta.env.VITE_SOCKET_URL ?? '',
  STREAMING_SOCKET_URL: window.env.VITE_STREAMING_SOCKET_URL ?? import.meta.env.VITE_STREAMING_SOCKET_URL ?? '',
  FONTS_URL: window.env.VITE_FONTS_URL ?? import.meta.env.VITE_FONTS_URL ?? '/api/v1/utils/fonts/{fontstack}/{range}.pbf',
  APP_NAME: window.env.VITE_APP_NAME ?? import.meta.env.VITE_APP_NAME ?? 'Urbis DeskApp', // possible values: Urbis Web Portal / Urbis DeskApp / Urbis Server Enterprise
  APP_VERSION: window.env.VITE_APP_VERSION ?? import.meta.env.VITE_APP_VERSION ?? '2.0',
  APP_PARTNER_LOGO: window.env.VITE_APP_PARTNER_LOGO ?? import.meta.env.VITE_APP_PARTNER_LOGO ?? undefined,
  APP_CITIZEN_LOGO: window.env.VITE_APP_CITIZEN_LOGO ?? import.meta.env.VITE_APP_CITIZEN_LOGO ?? undefined,
  APP_COLOR_THEME: window.env.VITE_APP_COLOR_THEME ?? import.meta.env.VITE_APP_COLOR_THEME ?? undefined,
  APP_DEFAULT_LOGO: window.env.VITE_APP_DEFAULT_LOGO ?? import.meta.env.VITE_APP_DEFAULT_LOGO ?? undefined,
  APP_MOBILE_LOGO: window.env.VITE_APP_MOBILE_LOGO ?? import.meta.env.VITE_APP_MOBILE_LOGO ?? undefined,
  APP_MODULE_TYPE: window.env.VITE_APP_MODULE_TYPE ?? import.meta.env.VITE_APP_MODULE_TYPE ?? undefined,
  APP_MOBILE_FOLDER: window.env.VITE_APP_MOBILE_FOLDER ?? import.meta.env.VITE_APP_MOBILE_FOLDER ?? undefined,
  APP_ORGANIZATION_NAME: window.env.VITE_APP_ORGANIZATION_NAME ?? import.meta.env.VITE_APP_ORGANIZATION_NAME ?? undefined,
  APP_ORGANIZATION_ID: window.env.VITE_APP_ORGANIZATION_ID ?? import.meta.env.VITE_APP_ORGANIZATION_ID ?? undefined,
  CAPTCHA_KEY: window.env.VITE_CAPTCHA_KEY ?? import.meta.env.VITE_CAPTCHA_KEY ?? '6LeTNVwpAAAAAJhav8aZqjSq5TkzGv19sh0XVe98',
  APP_TYPE: window.env.VITE_APP_TYPE || import.meta.env.VITE_APP_TYPE || 'default',
  APP_LOGO_BACKGROUND: window.env.VITE_APP_LOGO_BACKGROUND || import.meta.env.VITE_APP_LOGO_BACKGROUND || '#0069b6',
  WMTS_API_URL: window.env.VITE_WMTS_API_URL ?? import.meta.env.VITE_WMTS_API_URL ?? '',
  WMS_API_URL: window.env.VITE_WMS_API_URL ?? import.meta.env.VITE_WMS_API_URL ?? (window.env.VITE_WMTS_API_URL ?? import.meta.env.VITE_WMTS_API_URL ?? ''),
  WFS_API_URL: window.env.VITE_WFS_API_URL ?? import.meta.env.VITE_WFS_API_URL ?? (window.env.VITE_WMTS_API_URL ?? import.meta.env.VITE_WMTS_API_URL ?? ''),
  THEME_OVERWRITE: window.env.VITE_THEME_OVERWRITE ?? import.meta.env.VITE_THEME_OVERWRITE ?? undefined,
  APP_URBAN_PLANNER_LOGO: window.env.VITE_APP_URBAN_PLANNER_LOGO ?? import.meta.env.VITE_APP_URBAN_PLANNER_LOGO ?? undefined,
  APP_BOARD_LOGO: window.env.VITE_APP_BOARD_LOGO ?? import.meta.env.VITE_APP_BOARD_LOGO ?? undefined,
  USE_PROJECTION_TOGGLE_BUTTON: window.env.VITE_USE_PROJECTION_TOGGLE_BUTTON ?? import.meta.env.VITE_USE_PROJECTION_TOGGLE_BUTTON ?? undefined,
  DEFAULT_LOCATION:(window.env.VITE_DEFAULT_LOCATION ?? import.meta.env.VITE_DEFAULT_LOCATION) ? JSON.parse(window.env.VITE_DEFAULT_LOCATION ?? import.meta.env.VITE_DEFAULT_LOCATION) : undefined,
  SIGNALR_HUB_URL: window.env.VITE_SIGNALR_HUB_URL ?? import.meta.env.VITE_SIGNALR_HUB_URL ?? 'https://localhost:5001/ws/scanner',
  APP_TENANT_TITLE: window.env.VITE_APP_TENANT_TITLE ?? import.meta.env.VITE_APP_TENANT_TITLE ?? '',
  APP_TITLE: window.env.VITE_APP_TITLE ?? import.meta.env.VITE_APP_TITLE ?? '',
  APP_HELP_DOC: window.env.VITE_APP_HELP_DOC ?? import.meta.env.VITE_APP_HELP_DOC ?? '',
  APP_DESCRIPTION: window.env.VITE_APP_DESCRIPTION ?? import.meta.env.VITE_APP_DESCRIPTION ?? '',
  APP_NOTE: window.env.VITE_APP_NOTE ?? import.meta.env.VITE_APP_NOTE ?? '',
  APP_GDPR_LINK: window.env.VITE_APP_GDPR_LINK ?? import.meta.env.VITE_APP_GDPR_LINK ?? '',
  APP_CONTACT_LINK: window.env.VITE_APP_CONTACT_LINK ?? import.meta.env.VITE_APP_CONTACT_LINK ?? '',
  APP_PRIVACY_POLICY: window.env.VITE_APP_PRIVACY_POLICY ?? import.meta.env.VITE_APP_PRIVACY_POLICY ?? '',

};

if (settings.USE_VERSIONED_API?.toString()?.toLowerCase() === 'true') settings.USE_VERSIONED_API = true; else  settings.USE_VERSIONED_API = false;
if (settings.USE_PROJECTION_TOGGLE_BUTTON?.toString()?.toLowerCase() === 'true') settings.USE_PROJECTION_TOGGLE_BUTTON = true; else settings.USE_PROJECTION_TOGGLE_BUTTON = false;

if(isOffline()){
  settings.FONTS_URL = window.location.origin + "/fonts/{fontstack}/{range}.pbf";
}

switch (settings.APP_TYPE) {
  case 'default':
    settings.APP_MODULE_TYPE = 1;
    break
  case 'citizen':
    settings.APP_MODULE_TYPE = 2;
    break
  case 'public':
    settings.APP_MODULE_TYPE = 3;
    settings.APP_IFRAME_URL = window.env.VITE_APP_IFRAME_URL || import.meta.env.VITE_APP_IFRAME_URL;
    break
  case 'urban-planner':
    settings.APP_MODULE_TYPE = 4;
    break
  case 'board':
    settings.APP_MODULE_TYPE = 5;
    break
  case 'public-app':
    settings.APP_MODULE_TYPE = 10;
    break
  case 'syncmap':
  case 'mobile':
    if (!settings.APP_MODULE_TYPE) settings.APP_MODULE_TYPE = 6;
    break
}

export const config = settings
